import { StrokeColorUpdater } from "./StrokeColorUpdater.js";
export async function loadStrokeColorUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("strokeColor", (container) => new StrokeColorUpdater(container), refresh);
}
